import _extends from "@babel/runtime/helpers/extends";
import classNames from 'classnames';
import React, { createRef, useMemo } from 'react';
import { DropdownTheme, Dropdown as TPADropdown } from 'wix-ui-tpa/cssVars';
import { useConfig } from '../../../contexts/config-context';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import { useTranslation } from '../../../contexts/translation-context';
import { getMonthList } from './helpers';
import { classes } from './month-select-wut.st.css';
export function MonthSelectWUT(props) {
  const {
    id,
    className,
    onChange,
    ...rest
  } = props;
  const {
    t
  } = useTranslation();
  const {
    isMobile,
    locale
  } = useConfig();
  const dropdown = /*#__PURE__*/createRef();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const options = useMemo(() => getMonthList(locale).map((month, index) => ({
    value: month,
    id: `${index + 1}`,
    isSelectable: true
  })), [locale]);
  return /*#__PURE__*/React.createElement(TPADropdown, _extends({}, rest, {
    key: String(Boolean(props.value)),
    upgrade: true,
    ref: dropdown,
    newErrorMessage: true,
    mobileNativeSelect: isMobile,
    "aria-label": t('field.date.placeholder.month'),
    options: options,
    onChange: handleChange,
    initialSelectedId: props.value ? props.value.toString() : undefined,
    className: classNames(className, classes.root, classes.theme, {
      [classes.hover]: forcedHover,
      [classes.mobileDropdown]: isMobile
    }),
    theme: DropdownTheme.Box,
    flip: false
  }));
  function handleChange(option) {
    var _dropdown$current;
    onChange == null || onChange(option.id);
    // force focus to be within the "date field" so validation won't be triggered prematurely
    (_dropdown$current = dropdown.current) == null || _dropdown$current.focus();
  }
}
//# sourceMappingURL=month-select-wut.js.map